<template>
  <div >

    <el-form :inline="true" :model="addFrom" ref="addFrom" class="demo-form-inline" label-width="140px" size="mini">
      <div class="inpBox jiaoyan">
        <el-breadcrumb separator="/" style="margin-left:30px ;">
          <el-breadcrumb-item :to="{ path: '/management' }">业务管理</el-breadcrumb-item>
          <el-breadcrumb-item><a href="/">{{ this.title }}</a></el-breadcrumb-item>

        </el-breadcrumb>
        <br>

        <el-form-item label="重要程度" prop="importance" :rules="[
          { required: true, message: '请输入重要程度', trigger: 'change' },
        ]">
          <el-input placeholder="" maxlength="15" v-model="addFrom.importance"></el-input>
        </el-form-item>
        <el-form-item label="立项日期">
          <el-date-picker v-model="addFrom.projectApprovalDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="业务人员">
          <el-input placeholder="" maxlength="30" v-model="addFrom.businessPersonnel"></el-input>
        </el-form-item>
        <el-form-item label="业务类型">
          <el-input placeholder="" maxlength="30" v-model="addFrom.businessType"></el-input>
        </el-form-item>
        <el-form-item label="需方客户">
          <el-input placeholder="" maxlength="30" v-model="addFrom.demanderCustomer"></el-input>
        </el-form-item>
        <el-form-item label="上级订货客户">
          <el-input placeholder="" maxlength="30" v-model="addFrom.superiorOrderingCustomer"></el-input>
        </el-form-item>
        <el-form-item label="下级销售客户">
          <el-input placeholder="" maxlength="30" v-model="addFrom.subordinateSalesCustomer"></el-input>
        </el-form-item>
        <el-form-item label="结算客户">
          <el-input placeholder="" maxlength="30" v-model="addFrom.settlementCustomer"></el-input>
        </el-form-item>
        <el-form-item label="钢厂">
          <el-input placeholder="" maxlength="10" v-model="addFrom.steelMill"></el-input>
        </el-form-item>
        <el-form-item label="合约号">
          <el-input placeholder="" maxlength="100" v-model="addFrom.agreementNumber"></el-input>
        </el-form-item>
        <el-form-item label="合同号">
          <el-input placeholder="" maxlength="20" v-model="addFrom.contractNumber"></el-input>
        </el-form-item>
        <br>
        <div class="addressBox">
          <h4 class="title">
            <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>业务描述</span>
          </h4>
        </div>
        <el-form-item label="客户/订单来源">
          <el-input placeholder="" maxlength="15" v-model="addFrom.source"></el-input>
        </el-form-item>
        <el-form-item label="货物交付时间">
          <el-input placeholder="" maxlength="20" v-model="addFrom.deliveryTime"></el-input>
          <!-- <el-date-picker v-model="addFrom.deliveryTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
          </el-date-picker> -->
        </el-form-item>
        <el-form-item label="工艺要求简述">
          <el-input placeholder="" maxlength="50" v-model="addFrom.requirementDescription"></el-input>
        </el-form-item>
        <el-form-item label="物流流向">
          <el-input placeholder="" maxlength="20" v-model="addFrom.flowDirection"></el-input>
        </el-form-item>
        <el-form-item label="客户其他要求">
          <el-input placeholder="" maxlength="50" v-model="addFrom.customerRequirements"></el-input>
        </el-form-item>

        <br>
        <div class="addressBox">
          <h4 class="title">
            <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>货物信息</span>
          </h4>
        </div>
        <el-form-item label="货物类型" prop="productTypeName" :rules="[
          { required: true, message: '请选择货物类型', trigger: 'change' },
        ]">

          <el-select size="mini" @change="DHway(addFrom.productTypeName)" v-model="addFrom.productTypeName"
            placeholder="请选择">
            <el-option v-for="(item, index) in typeData" :label="item.show_name" :key="index"
              :value="item.show_name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="计划件数" prop="planNumber" :rules="[
          { required: true, message: '请输入计划件数', trigger: 'change' },
        ]">
          <el-input placeholder="" maxlength="11" v-model.number="addFrom.planNumber"></el-input>
        </el-form-item>
        <el-form-item label="单件重量（吨）">
          <el-input placeholder="" maxlength="10" v-number-input.float="3"  v-model="addFrom.singleWeight"></el-input>
        </el-form-item>
        <el-form-item label="计划吨数（吨）" prop="planWeight" :rules="[
          { required: true, message: '请输入计划吨数', trigger: 'change' },
        ]">
          <el-input placeholder="" maxlength="10" v-number-input.float="3"  v-model="addFrom.planWeight"></el-input>
        </el-form-item>
        <div class="footerBtn">
          <el-button type="primary" class="bigBtn" @click="back">返回</el-button>
          <el-button type="primary" class="bigBtn" @click="saveFn(1)">保存</el-button>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { zidian, addBusinessManagement, updateBusinessManagement } from '@/api/wms-stock'
export default {
  data () {
    return {
      id: this.$route.query.id,
      addFrom: this.$route.query.addFrom,
      title: this.$route.query.title,
      typeData: [],
      addFrom: {
      }
    }
  },
  created () {
    zidian({
      groupNo: 'product_type'
    })
      .then((res) => {
        this.typeData = res
      })
      .catch((err) => {
        DonMessage.error(err.message)
      })
  },
  mounted () {
    if (this.title == '修改业务') {
      this.addFrom = { ...this.$route.query.addFrom }
    }
  },
  methods: {

    DHway (valueS) {
      this.addFrom.productType = this.typeData.filter((item) => item.show_name === valueS)[0].item_no
    },
    saveFn (flag) {
      this.$refs.addFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          if (this.title == '修改业务') {
            updateBusinessManagement(this.addFrom)
              .then((res) => {
                loading.close()
                this.$message({
                  message: '操作成功',
                  type: 'success'
                })
                this.$router.go(-1)// 返回上一层
              })
              .catch((err) => {
                DonMessage.error(err.message)
              })
          } else {
            addBusinessManagement(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '操作成功',
                type: 'success'
              })
              this.$router.go(-1)// 返回上一层
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        } else {
          return false
        }
      })
    },
    back () {
      this.$router.go(-1)// 返回上一层
    }
  }
}
</script>

<style scoped lang='less'>
/deep/.el-upload--text {
  width: 100px;
  height: 100px;
  border: 1px #ddd solid;
}

/deep/.el-upload--text i {
  font-size: 50px;
  margin-top: 25px;
}

.hidden /deep/.el-upload--text {
  display: none;
}

.width1 /deep/.el-input__inner {
  width: 350px;
}

.width2 /deep/.el-input__inner {
  width: 450px;
}

.inpBox /deep/.el-date-editor .el-input__inner {
  width: 150px;
}

.datefanwei /deep/.el-input__inner {
  width: 350px;
}

/deep/.el-textarea {
  width: 753px;
}

/deep/.el-input.is-disabled .el-input__inner {
  color: #606266;
}
</style>
